import { render, staticRenderFns } from "./ViewTrainingRegistrationDetails.vue?vue&type=template&id=69d9c3ca"
import script from "./ViewTrainingRegistrationDetails.vue?vue&type=script&lang=js"
export * from "./ViewTrainingRegistrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports